import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import FBPostModel from '../model/FBPostModel';
import { CampaignScheduleType } from '../model/CampaignsModel';

type CommentGuardPromoterCreateParams = {
  message?: string;
  postId: string;
  postInfo: FBPostModel;
};

export type StartBotPromoterCreateParams = CommentGuardPromoterCreateParams;

type StartBotResponse = {
  startBot: {
    pageId: number;
    promoterId: number;
  };
  errors: string[];
  success: boolean;
};

export type StartBotFromCampaign = {
  id: number;
  name: string;
  scheduleType: CampaignScheduleType;
  sortOrder: number;
  destinationPageId: number;
};

export type CampaignStartBotResponse = {
  startBots: {
    [key: string]: StartBotFromCampaign[];
  };
};

class StartBotController extends AuthenticatedController {
  static create(
    botId: number,
    kind: string,
    promoterCreateParams?: StartBotPromoterCreateParams,
  ): Promise<StartBotResponse> {
    return super.post(APIRoutes.START_BOTS(botId, ''), {
      kind,
      promoterCreateParams,
    });
  }

  static async retrieveCampaignStartbots(
    botId: number,
  ): Promise<CampaignStartBotResponse> {
    return super.get(APIRoutes.CAMPAIGN_START_BOTS(botId));
  }
}

export default StartBotController;
